


  <div *ngIf="!IsEditLocation">
    <span style="cursor:pointer" class="q-c-main" (click)="OpenEditLocation()" *ngIf="IsLoaded"><i class="fas fa-home fa-lg"></i><i style="transform:translateY(-6px)" class="fas fa-plus fa-1x"></i></span>
    <p *ngIf="adresseInfos && adresseInfos.AdresseComplete && adresseInfos.AdresseComplete.length > 0" [title]="adresseInfos.AdresseComplete">{{adresseInfos.Denomination}} - {{adresseInfos.VilleAdress}}</p>
  </div>
  <div *ngIf="IsEditLocation">
    <div class="d-flex flex-row-reverse">
      <i class="fas fa-undo q-c-danger mx-2 q-pointer" (click)="CloseEditLocation()"></i>
    </div>
    <select class="q-main-select m-2" (change)="GetConvocationLocation($event.target.value)" [disabled]="(idClientSelected && idClientSelected != '0') || (adresseInfos.Ident && adresseInfos.Ident != '0')">
      <option *ngFor="let adr of adresseInfos.ListConvocationLocation" [selected]="adr.id != null && adr.id == adresseInfos.Ident" value="{{adr.id}}">{{adr.value}}</option>
    </select>
    <select class="q-main-select m-2" (change)="GetClientLocation($event.target.value)" [disabled]="(idLocationConvocationSelected && idLocationConvocationSelected != '0') || (adresseInfos.Ident && adresseInfos.Ident != '0')">
      <option *ngFor="let client of adresseInfos.ListClient" value="{{client.id}}">{{client.value}}</option>
    </select>
    <q-bodisplay class="w-100 h-100 mb-5" [param]="paramBO" (sendEvent)="CloseEditLocation()" *ngIf="showBo"></q-bodisplay>
    <div *ngIf="!showBo" style="display: block; height: 100%; width: 100%; text-align: center">
      <div class="fa-3x">
        <i class="fas fa-spinner fa-pulse fa-spin q-c-main"></i>
      </div>
    </div>
  </div>

